import { createStateContext } from '../../../factory'

export const [ShopDetailContext, useShopDetailContext] = createStateContext({
  signUpScreenOpen: false,
  redirectUrl: '',
  productId: '',
  eventParams: {},
})
